import { map } from 'ramda';
import Table from './Table';
import Phone from './Phone';

const LinkNewRequest = ({ props: { value }}) => (
	<a
		class="request-edit-link underline"
		href={ `/personal/requests/new/?client=${value}` }
		target="_blank"
	>
		Новая заявка
	</a>
);

const ListRequest = ({ props: { value: list }}) => (
	<ul class="list-unstyled m-0">
		{ map((item) => (
			<li>
				<a
					class="request-edit-link underline"
					href={ item.url }
					target="_blank"
				>
					{ item.number }
				</a>
			</li>
		), list) }
	</ul>
);

const columns = [
	{
		dataIndex: 'clientPhone',
		render: Phone,
	},
	{
		dataIndex: 'clientName',
	},
	{
		dataIndex: 'clientId',
		render: LinkNewRequest,
	},
	{
		dataIndex: 'requests',
		render: ListRequest,
	},
];

const TableCalls = ({ data }) =>
	<Table
		striped={ true }
		columns={ columns }
		showHeader={ false }
		{ ...data }
	/>

export default TableCalls;
